export const PLAY_TRACK_BY_TRACK_ID = "PLAY_TRACK_BY_TRACK_ID";
export const RADIO_PLAY = "RADIO_PLAY";
export const RADIO_PAUSE = "RADIO_PAUSE";
export const RADIO_STOP = "RADIO_STOP";
export const RADIO_NEXT_TRACK = "RADIO_NEXT_TRACK";
export const RADIO_SHUFFLE_OFF = "RADIO_SHUFFLE_OFF";
export const RADIO_SHUFFLE_ON = "RADIO_SHUFFLE_ON";
